
import { computed } from "@vue/reactivity";
import { ref } from "vue";
import router from "../router"; // <---

export default {
  props: ["baseUrl"],
  setup(props: any) {
    const userName = ref("");
    const password = ref("");
    const loginResult = ref("");
    const baseUrlAddress = computed(() => {
      return `${props.baseUrl}`;
    });
    const registrationUrl = "/#/register";

    console.log("registrationUrl : ", registrationUrl);

    const login = () => {
      loginResult.value="";
      var requestUrl = baseUrlAddress.value + "Login/UserLoginForToken";
      //var requestUrl = "http://emergingsols2.somee.com/Login/UserLoginForToken";

      //console.log("requestUrl : ", requestUrl);

      var requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // 'Authorization':`Bearer ${token }`
        },
        body: JSON.stringify({
          UserId: 0,
          UserName: userName.value, //"Shouket", //
          Password: password.value, //"ALLAH1", //
        }),
      };

      fetch(requestUrl, requestOptions)
        .then((response) => // response.json()
        {
          let jsonResponse = null;
          console.log("value of response : ", response);
          if(response != null && response.ok== true )
          {
            jsonResponse = response.json();
          }
          else
            loginResult.value = "Could not login please try again.";
          return jsonResponse;
        }
        ).then((result) => {
          localStorage.setItem("Guardtoken","");
          //console.log("result", result.loginResultUserViewModel);
          if (result.loginResultUserViewModel?.token != null) {
            localStorage.setItem(
              "Guardtoken",
              result.loginResultUserViewModel?.token
              );
              
            //console.log("Guardtoken ", localStorage.getItem("Guardtoken"));

            localStorage.setItem(
              "OfficerId",
              result.loginResultUserViewModel?.officerId
            );

            // console.log("Guardtoken ", result.loginResultUserViewModel);

            localStorage.setItem("UserLoginId", result.loginResultUserViewModel?.id );
            localStorage.setItem("officerName", result.officerName);
            // router.push("schedule");
            router.push("jobcalls");
            router.push("profile");
          }
        })
        .then((Error) =>{
          //alert("Could not login please try again.");
          console.log("Error : " , Error);
          loginResult.value = "Error Occurred and could not login please try again.";
        });
    };

    

    return {
      userName,
      password,
      login,
      baseUrlAddress,
      loginResult,
      registrationUrl,
    };
  },
};
